export const APP_STORE_URL = 'https://apps.apple.com/de/app/krug-dijaspora/id6801919231?l=en-GB';
export const GOOGLE_PLAY_URL = '';
